module.exports = __webpack_public_path__ + "img/txnPending.dcf0ca44.svg";